import { Redirect, Switch } from 'react-router'

import { ProtectedRoute } from '@webapp/app/components'
import { useModuleConfig } from '@webapp/app/config/useModuleConfig'
import { useAppRoutes } from '@webapp/hooks/useAppRoutes'
import { ReceiveDetailsPage } from '@webapp/pages'
import {
  ReceiveListPage,
  ReceiveListPageTabStatuses,
} from '@webapp/pages/ReceiveListPage'

const receiveStatusFormat = Object.values(ReceiveListPageTabStatuses).join('|')

export const ReceiveRouter = () => {
  const { url, brp } = useAppRoutes()

  const {
    routes: { enablePurchasingRoutes },
  } = useModuleConfig()

  if (!enablePurchasingRoutes) return <Redirect to={url('DashboardPage')} />

  return (
    <Switch>
      <ProtectedRoute
        exact
        path={brp('ReceiveDetailsPage', {
          uuid: `:uuid(${/[0-9a-fA-F]{32}/.source})`,
        })}
        component={ReceiveDetailsPage}
        navigationPermissions={['receive']}
      />
      <ProtectedRoute
        path={brp('ReceiveListPage', {
          status: `:status(${receiveStatusFormat})`,
        })}
        component={ReceiveListPage}
        navigationPermissions={['receive']}
      />
      <Redirect
        path={brp('ReceiveListPage', {
          status: '',
        })}
        to={brp('ReceiveListPage', {
          status: 'open',
        })}
      />
    </Switch>
  );
}
